<style src="./PanelTab.scss" lang="scss" scoped></style>
<template>
  <ul class="panel-tab">
    <slot />
  </ul>
</template>

<script>
export default {
  name: 'PanelTab',
  data () {
    return {}
  },
  mounted () {
    this.$on('choose-item', (pItem) => {
      this.$emit('change-panel', pItem)
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/primitives/panel-tab/PanelTab.vue